import { AnnotationOutput } from '../../team-apis/otterdam/outputs/annotation-output';
import { Project } from '../../team-apis/otterdam/project';
import { Task, TaskExtras } from '../../team-apis/otterdam/task';
import { User } from '../../team-apis/otterdam/user';
import { ToolName } from '../tools-names';
import { ObjectWith } from '../types/misc';
import { MouseState } from './mouse-state';
import { ShapeGroupState, ShapeOrGroupOrderItem } from './shape-group-state';

export type ViewMode = 'layers' | 'all' | 'selected' | 'none';

export interface ShapeFilter {
  outputName: string;
  filterNames: string[];
}

export abstract class AbstractSensorContentState {
  currentUser!: User;
  output!: AnnotationOutput;
  project!: Project;
  shapeCreationEnabled = true;
  readOnly = false;
  isShapeFeedbackEditable!: boolean;
  isClientFeedbacksEditable!: boolean;
  selectedTool?: ToolName;
  groups!: ObjectWith<ShapeGroupState>;
  shapeAndGroupOrder!: ShapeOrGroupOrderItem[];
  taskExtras?: TaskExtras;
  status!: 'loading' | 'ready';
  stepId?: number;
  task!: Task;
  // ratio between shape width/height and viewBox width/height
  viewBoxPadding?: number;
  abstract mouse: MouseState;
}
